


















import { Vue, Component, Prop } from "vue-property-decorator";
@Component({
  name: "LayoutRow",
  components: {}
})
export default class LayoutRow extends Vue {
  @Prop({
    required: true
  })
  private row!: App.WebForm.Row;

  @Prop({
    required: true
  })
  private options!: App.WebForm.Config;

  @Prop({
    required: true
  })
  private config!: App.WebForm.ServiceOriginConfig;

  @Prop({
    required: true
  })
  private model!: "preview" | "normal";

  get rowClassList() {
    const classList: any = {};
    if (this.row.level) {
      classList["layout-row-level-" + this.row.level] = true;
    } else {
      classList["layout-row-level-1"] = true;
    }
    return classList;
  }
}
